import { inject, Injectable, signal } from '@angular/core';
import { UserService } from '@praceprofirmy/user-domain';

@Injectable({
  providedIn: 'root',
})
export class ApplicationStateService {
  private readonly userService = inject(UserService);

  readonly users = signal<any[]>([]);

  loadUsersToSystem() {
    this.userService.fetchUsers().subscribe({
      next: value => {
        this.users.update(() => value.result);
        console.log(value);
      },
    });
  }
}
